import { render } from "./AddUserGroup.vue?vue&type=template&id=41ccff7e"
import script from "./AddUserGroup.vue?vue&type=script&lang=js"
export * from "./AddUserGroup.vue?vue&type=script&lang=js"
script.render = render

export default script